import { render, staticRenderFns } from "./FormContactsList.vue?vue&type=template&id=07873612&"
import script from "./FormContactsList.vue?vue&type=script&lang=js&"
export * from "./FormContactsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports